// The wait a customer is told (Reception) and the accuracy report. English only for now.
import type { Phrase } from '../staffText'

const en = (text: string): Phrase => ({ en: text })

export const estimate = {
  'estimate.min': en('~{m} min'),
  'estimate.range': en('~{low}–{high} min'),
  'estimate.over': en('2 h+'),
  'estimate.noDesk': en('No desk open'),
  'estimate.late': en('May not be served today'),
  'estimate.nWaiting': en('{n} waiting, {wait}'),
  'estimate.nobodyWaiting': en('Nobody waiting, {wait}'),

  // The accuracy report.
  'estimate.report.none': en('Nothing to compare in this period'),
  'estimate.report.day': en('Day'),
  'estimate.report.queue': en('Queue'),
  'estimate.report.tickets': en('Tickets'),
  'estimate.report.median': en('Median error'),
  'estimate.report.within': en('Within 5 min'),
  'estimate.report.longer': en('Waited longer'),
  'estimate.report.shorter': en('Waited less'),
  'estimate.report.mean': en('Mean error'),
  'estimate.report.byDay': en('By day and queue'),
  'estimate.report.live': en("Today's pace"),
}
